import {Component, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {MatSnackBar} from '@angular/material/snack-bar';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {BankAccountDetails} from '../../admin/users/user/bank.account.details';
import { BiometricService } from './biometric.service';
import { FaceInitiateCallbackResults } from 'src/app/profile/verify-contact-details/face.initiate.callback.results';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-bank-account-check-verification-status',
  templateUrl: './bio-metric.component.html',
  styleUrls: ['./bio-metric.component.scss']
})
export class BioMetricComponent implements OnInit, OnDestroy {

  @Input() url: string;
  @Input() pin: string;
  @Input() startVerification: boolean = true;
  @Input() bankAccountDetails: BankAccountDetails;
  @Input() idNumber: string | null = null;
  @BlockUI() blockUI: NgBlockUI;
  private isActive = true;

  safeUrl: SafeUrl;
  localPin: string;
  localUrl: string;

  constructor(protected _sanitizer: DomSanitizer, private biometricService: BiometricService,
              public matSnackBar: MatSnackBar,public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.url !== null && this.url !== undefined) {
      this.safeUrl = this._sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }
    if (this.startVerification) {
      this.startBiometricVerification();
    } else {
      this.localPin = this.pin;
      setTimeout(()=> {
        this.checkStatus();
      }, 10000);
    }
  }

  startBiometricVerification() {
    if (this.idNumber === null || this.idNumber === undefined) {
      throw new Error("Biometric cannot be initiated");
    }
    this.blockUI.start();
    this.biometricService.startVerification(this.idNumber).subscribe((data: FaceInitiateCallbackResults) => {
      this.localPin = data.pincode;
      this.safeUrl = this._sanitizer.bypassSecurityTrustResourceUrl(data.link);
      this.blockUI.stop();
      setTimeout(() => {        
        this.checkStatus();
      }, 10000);
    }, (error) => {
      this.blockUI.stop();
      this.activeModal.close(null);      
    })
  }

  checkStatus() {
    if (this.idNumber === null || this.idNumber === undefined) {
      throw new Error("Biometric cannot be initiated");
    }
    this.biometricService.checkVerificationStatus(this.localPin, this.idNumber).subscribe(status => {
      if (status ==='false') {
        if (this.isActive) {
          setTimeout(() => {
            this.checkStatus();
          }, 10000);
        }
      } else {
        this.activeModal.close(this.localPin);
        this.matSnackBar.open('Successfully verified', 'Okay', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      }
    })
  }

  ngOnDestroy(): void {
    console.log("Destroyed called");
    this.isActive = false;
  }
}
